import React from 'react';

export const path =
  'M7.006,5.298 L7.006,1 L2.7,1 C2.238,1 2,1.252 2,1.7 L2,12.3 C2,12.748 2.238,13 2.7,13 L11.304,13 C11.752,13 12.004,12.748 12.004,12.3 L12.004,5.998 L7.706,5.998 C7.244,5.998 7.006,5.76 7.006,5.298 Z M8.35,5.004 L12.004,5.004 L8,1 L8,4.654 C8,4.878 8.126,5.004 8.35,5.004 Z';

export default class Asterisk extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <path d={path} className="fill-current" />
      </g>
    );
  }
}
